import axios from "axios";
export const state = {
    all_lab_items: [],
    stock: [],
    disbursed: [],
    approved_requisitions: [],
    pending_requisitions: [],
    my_requisitions: [],
    stock_cart: [],
    total_cart: "",
    req_cart: "",
    save_status: false,
};
export const getters = {
    LabItems: state => state.all_lab_items.data,
    InventoryStock: state => state.stock.data,
    DisbursedStock: state => state.disbursed.data,
    SaveStatus: state => state.save_status,
    MyRequisitions: state => state.my_requisitions.data,
    PendingRequisitions: state => state.pending_requisitions.data,
    ApprovedRequisitions: state => state.approved_requisitions.data,
    StockCart: state => state.stock_cart.data,
    RequisitionCart: state => state.req_cart.data,
    TotalCart: state => state.total_cart,
};

export const mutations = {
    SET_LAB_ITEMS(state, newValue) {
        state.all_lab_items = newValue;
    },
    SET_STOCK(state, newValue) {
        state.stock = newValue
    },
    SET_DISBURSED(state, newValue) {
        state.disbursed = newValue
    },
    SET_APPROVED(state, newValue) {
        state.approved_requisitions = newValue
    },
    SET_PENDING(state, newValue) {
        state.pending_requisitions = newValue
    },
    SET_REQUISITIONS(state, newValue) {
        state.requisitions = newValue
    },
    SET_REQUISITION_CART(state, newValue) {
        state.req_cart = newValue
    },
    SET_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_STOCK_CART(state, newValue) {
        state.stock_cart = newValue
    },
    SET_TOTAL_CART(state, newValue) {
        state.total_cart = newValue
    },
    SET_DRUGS(state, newValue) {
        state.items = newValue
    },
    SET_MY_REQUISITIONS(state, newValue) {
        state.my_requisitions = newValue
    },
   
};

export const actions = {
    addLabItem({ commit,dispatch },payload) {
        commit('SET_STATUS', true);
        axios.post('lab_items',payload).then(() => {
            dispatch('fetchLabItems');
            let message = { 'msg': `Lab Item ${payload.name} added successfully` }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STATUS', false); 
        }).catch(() => {
            commit('SET_STATUS', false)
            let message = { 'msg': "Error Adding Item" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Lab Inventory Item
    editLabItem({ commit,dispatch },payload) {
        commit('SET_STATUS', true);
        axios.put(`lab_items/${payload.id}`, payload).then(() => {
            dispatch('fetchLabItems');
            let message = { 'msg': `Lab Item ${payload.name} updated successfully` }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STATUS', false); 
        }).catch(() => {
            commit('SET_STATUS', false)
            let message = { 'msg': "Error updating Item" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Lab Inventory Item
    deleteLabItem({ commit,dispatch },payload) {
        // console.log(payload);
        commit('SET_STATUS', true);
        axios.delete(`lab_items/${payload.id}`).then(() => {
            dispatch('fetchLabItems');
            let message = { 'msg': `Lab Item ${payload.name} deleted successfully` }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
            commit('SET_STATUS', false); 
        }).catch(() => {
            commit('SET_STATUS', false)
            let message = { 'msg': "Error deleting Lab Item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    addToCart({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.post('labstock', data).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Item added successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to add item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to add item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    addRequisition({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.post('temp_requisitions', data).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchRequisitionCart')
            if (response.status==200){
                let message = { 'msg': "Item added successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to add item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to add item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCart({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.put(`labstock/${data.id}`, data).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Item edited successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to edit item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to edit item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editRequisition({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.put(`temp_requisitions/${data.id}`, data).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchRequisitionCart')
            if (response.status==200){
                let message = { 'msg': "Item edited successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to edit item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to edit item" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editSup({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.post(`edit_lab_supplier`, data).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Supplier edited successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to edit Supplier" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to edit Supplier" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCart({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.delete(`labstock/${data.id}`).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Item deleted successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to delete item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': data.name+' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteRequisition({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.delete(`temp_requisitions/${data.id}`).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchRequisitionCart')
            if (response.status==200){
                let message = { 'msg': "Item deleted successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to delete item" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': data.name+' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteReq({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.delete(`requisitions/${data.id}`).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchPending')
            dispatch('fetchApproved')
            if (response.status==200){
                let message = { 'msg': "Requisition deleted successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to delete Requisition" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': data.name+' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    savePurch({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.post(`savelabstock`, data).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status==200){
                let message = { 'msg': "Purchase Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to record Purchase" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to record Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },

    saveRequisition({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.post(`requisitions`, data).then(response => {
            commit('SET_STATUS', false)

            if (response.status==200){
                dispatch('fetchRequisitionCart')
                dispatch('fetchRequisitionCart')
                dispatch('fetchReqs')
                let message = { 'msg': "Requisition submitted successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Requisition failed"}
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to record Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },

    ReqApprove({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.post(`approve`, data).then(response => {
            commit('SET_STATUS', false)
            dispatch('fetchPending')
            dispatch('fetchApproved')
            if (response.status==200){
                let message = { 'msg': "Requisition Approved successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to Approve Items" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to Approve Items" }
            dispatch('notification/error', message, { root: true })
        })
    },

    ReqDisburse({ dispatch, commit }, data) {
        commit('SET_STATUS', true)
        axios.post(`disburse`, data).then(response => {
            commit('SET_STATUS', false)
            if (response.status==200){
                dispatch('fetchDisbursed')
                dispatch('fetchReqs')
                dispatch('fetchPending')
                dispatch('fetchApproved')
                let message = { 'msg': "Requisition Disbursed successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to Disburse Items" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_STATUS', false)
            let message = { 'msg': "Failed to Disburse Items" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchCart({ commit }) {
        axios.get('labstock').then(cart => {
            commit('SET_STOCK_CART', cart.data)
        })
    },

    fetchRequisitionCart({ commit }) {
        axios.get('temp_requisitions').then(cart => {
            commit('SET_REQUISITION_CART', cart.data)
        })
    },
    fetchTotCart({ commit }) {
        axios.get('total_lab_cart').then(total => {
            commit('SET_TOTAL_CART', total.data)
        })
    },
    fetchLabItems({ commit }) {
        axios.get('lab_items').then(ec_res => {
            commit('SET_LAB_ITEMS', ec_res.data)
        })
    },
    fetchLabStock({ commit }) {
        axios.get('lab_stock').then(e_res => {
            commit('SET_STOCK', e_res.data)
        })
    },
    fetchDisbursed({ commit }) {
        axios.get('disbursed').then(e_res => {
            commit('SET_DISBURSED', e_res.data)
        })
    },
    fetchPending({ commit }) {
        axios.get('pending').then(e_res => {
            commit('SET_PENDING', e_res.data)
        })
    },
    fetchApproved({ commit }) {
        axios.get('approved_reqs').then(e_res => {
            commit('SET_APPROVED', e_res.data)
        })
    },
    fetchReqs({ commit }) {
        axios.get('requisitions').then(e_res => {
            commit('SET_MY_REQUISITIONS', e_res.data)
        })
    },
  
};